import { render, staticRenderFns } from "./AppDocumentHistoryItem.vue?vue&type=template&id=8ca2d892"
import script from "./AppDocumentHistoryItem.vue?vue&type=script&lang=js"
export * from "./AppDocumentHistoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports